import { Button, Card, Col, Input, message, Modal, Row, Spin } from "components/common";
import { useEffect, useState } from "react";
import { callGetApiWithAuth, callPostApiWithAuth } from "utils/api";

export default function GoogleAuthModal(props) {

    const [code, setCode] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const onRegisterSuccess = () => {
        message.success("Google Authenticator Enabled Successfully.");
        props.setModal(false);
        props.getAuthenticatorStatus()
        setIsLoading(false);
    }

    const onRegister = () => {
        setIsLoading(true)
        callPostApiWithAuth("my_account/setting/enable_2fa", {
            code: code,
        }, onRegisterSuccess, () => {
            setIsLoading(false)
        });
    }

    return <Modal onCancel={() => props.setModal(false)} visible={props.visible}>
        <Google2FACard onRegister={onRegister} code={code} setCode={setCode} secret={props.secret} image={props.qrImage} isLoading={isLoading}/>
    </Modal>
}

const Google2FACard = ({
    secret,
    image,
    code,
    setCode,
    onRegister,
    isLoading
}) => {

return <Card >
        <Row style={{ margin: "24px 0px" }}>
            <div>
                <div style={{ color: '#000', fontSize: "16px" }}>
                    Open Google Authenticator, choose Show QR code on this page, then use the app to scan the code. Alternatively, you can type a secret key.
                </div>
                <div style={{display: "flex", justifyContent: "space-around", alignItems: "center", marginTop: "20px"}}>
                    <div dangerouslySetInnerHTML={{ __html: image }}></div>
                    <span style={{ color: "#000", cursor: "pointer" }}>{secret}</span>
                </div>
            </div>
        </Row>
        <Row style={{ margin: "24px 0px" }}>
            <div style={{ display: "flex", justifyContent: "space-around", width: "100%", marginTop: '24px' }}>
                <Input label="6 digit code" width={30} value={code} onChange={(e) => setCode(e.target.value)} />
                <Button onClick={onRegister} style={{ float: "right" }}>{isLoading?<Spin spinning={true}/>:"Register"}</Button>
            </div>
        </Row>
    </Card>
}